/*
 *  I18VENTGAINEI18n.js
 *
 *  Created by Sébastien Hecart on 2018-08-04 11:41:15 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I18VENTGAINE_SECTION_0_TITLE: "Calcul d'une gaine de ventilation pour amené d'air dans une chaufferie gaz",
  I18VENTGAINE_in_debitGaine: 'Débit dans la gaine',
  I18VENTGAINE_in_pressionAtmospherique: 'Pression atmosphérique',
  I18VENTGAINE_rugosite_uuid: '',
  I18VENTGAINE_I03PSYCHROAIR: "Caractéristiques de l'air",
  I18VENTGAINE_res_masseVolAir: "Masse volumique de l'air",
  I18VENTGAINE_res_viscCine: 'Viscosité cinématique',
  I18VENTGAINE_SECTION_1_TITLE: 'Choix de la gaine',
  I18VENTGAINE_in_vitesse: 'Vitesse souhaitée',
  I18VENTGAINE_in_mode_gaine: 'Dn Gaine Eurovent',
  I18VENTGAINE_in_mode_gaine_0: 'Carré et rectangulaire',
  I18VENTGAINE_in_mode_gaine_1: 'Circulaire',
  I18VENTGAINE_SECTION_2_TITLE: 'Résultats optimum',
  I18VENTGAINE_res_dnEquivalent: 'DN équivalent circulaire',
  I18VENTGAINE_res_grandcote: 'Grand côté',
  I18VENTGAINE_res_petitcote: 'Petit côté',
  I18VENTGAINE_res_dngainecircu: 'Dn gaine eurovent circulaire',
  I18VENTGAINE_perteCharg_uuid: 'Unite de la perte de charge',
  I18VENTGAINE_res_pdcLinaire: 'Perte de charge linéaire',
  I18VENTGAINE_res_vitesseReel: 'Vitesse réel',
  I18VENTGAINE_SECTION_3_TITLE: 'Résultats rectangulaire par choix des côtes de la conduite'
}
